<script setup lang="ts">
  defineProps({
    message: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    }
  });

  const emit = defineEmits(['retry']);
  const isRetryDisabled = ref(false);

  const retry = async () => {
    emit('retry');
    isRetryDisabled.value = true;
  };
</script>

<template>
  <div class="chat-error">
    <div class="chat-error__heading">
      <div class="chat-error__time">{{ $d(time, 'long') }}</div>
    </div>
    <div class="chat-error__body">
      <div class="chat-error__bg">
        <div class="chat-error__title">
          <div />
          <p>{{ $t('chat.chameleonError.title') }}</p>
        </div>
        <div class="chat-error__content">{{ message }}</div>
        <button
          :disabled="isRetryDisabled"
          @click.prevent.stop="retry">
          {{ $t('chat.resend') }}
        </button>
      </div>
    </div>
  </div>
</template>
